import { Rt } from './Rt.js';
import { Rc } from './Rc.js';

export async function checkLoginState() {
	const { code } = await Rt.request.get('/admin/login-state');
	return code === Rc.DONE;
}

export async function logout() {
	const { code, data } = await Rt.request.get('/admin/logout');
	if (code !== Rc.DONE) {
		throw new Error('Logout failed');
	}
	return data;
}
